import { createAction, props } from '@ngrx/store';
import { Map, MapView } from '../models/Map';
import { MapPlace } from '../models/MapPlace';
import { Sector } from '../models/Sector';

export const MAP_FEATURE = 'map';

export const setMap = createAction(
  '[map] Set Map',
  props<{ map: Map }>()
);

export const setSectors = createAction(
  '[sectors] Set Sectors',
  props<{ sectors: Sector[] }>()
);

export const setSelectedSector = createAction(
  '[selectedSector] Set Selected Sector',
  props<{ selectedSector: Sector }>()
);

export const setShow = createAction(
  '[show] Set Show',
  props<{ isShowing: boolean }>()
);

export const setView = createAction(
  '[view] Set View',
  props<{ view: MapView }>()
);

export const setLoading = createAction(
  '[loading] Set Loading',
  props<{ isLoading: boolean }>()
);


